<template>
  <!-- eslint-disable vue/max-len -->
  <svg
    width="42"
    height="23"
    viewBox="0 0 42 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.968 22.5001L34.425 5.83313C34.4461 5.79173 34.4558 5.74587 34.4532 5.69987C34.4507 5.65388 34.4359 5.60926 34.4104 5.57023C34.3849 5.5312 34.3495 5.49904 34.3074 5.47677C34.2653 5.45451 34.2181 5.44288 34.17 5.44298H23.981C23.8747 5.44308 23.7705 5.47179 23.6803 5.52585C23.5901 5.57991 23.5176 5.65715 23.471 5.74877L15.747 20.9683C15.5137 21.4261 15.151 21.8119 14.7002 22.0817C14.2493 22.3516 13.7285 22.4947 13.197 22.4947C12.6655 22.4947 12.1447 22.3516 11.6938 22.0817C11.243 21.8119 10.8803 21.4261 10.647 20.9683L0 0.000117606H6.315L12.94 13.0542C12.9631 13.1002 12.9993 13.139 13.0444 13.1662C13.0895 13.1934 13.1417 13.2078 13.195 13.2078C13.2483 13.2078 13.3005 13.1934 13.3456 13.1662C13.3907 13.139 13.4269 13.1002 13.45 13.0542L19.3 1.53386C19.5324 1.07483 19.8947 0.687648 20.3456 0.416465C20.7964 0.145282 21.3177 0.0010154 21.85 0.000117606H39.108C39.5149 -0.00347036 39.9181 0.075076 40.2912 0.23065C40.6644 0.386224 40.9993 0.615342 41.274 0.903108C41.6508 1.30606 41.8939 1.80745 41.9723 2.34335C42.0506 2.87925 41.9607 3.42539 41.714 3.91212L32.282 22.5001H25.968Z"
      fill="var(--color-icon-default)"
    />
  </svg>
</template>
